import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the accounts and factoring api
 */
export class GeospatialOptionsService extends BaseService {

	constructor() {	
		super();
	}
	
	async getEnignes() {	
		var data = await this.makeGETRequest('/api/resource/geospatial-options/available-engines');		
		return data;		
	}	
	
	async getOptions(companyId) {	
		var data;
		if (companyId) {
			data = await this.makeGETRequest('/api/resource/geospatial-options?companyId=' + companyId);		
		} else {
			data = await this.makeGETRequest('/api/resource/geospatial-options');		
		}
		return data;		
	}
	
	async getOptionsForCurrentCompany() {	
		var data = await this.makeGETRequest('/api/resource/geospatial-options/current-company');				
		return data;		
	}	
		
	async saveOptions(options, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/geospatial-options/' + options.engineOptionsId, options);
		} else {
			saved = await this.makePOSTRequest('/api/resource/geospatial-options', options);
		}
		return saved;		
	}	

	
}
